import { makeStyles } from "@material-ui/core";

import type { CoretexTheme } from "../../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    position: "absolute",
    zIndex: 99,
    display: "flex",
    flexDirection: "column",
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.mono.white,
    boxShadow: theme.elevation.standard,
    borderRadius: theme.spacing(2),
  },
  action: {
    fontSize: 14,
    color: theme.palette.colour.primaryBlue,
    padding: theme.spacing(2),
    cursor: "pointer",
    textAlign: "right",
  },
  stack: {
    marginBottom: theme.spacing(2),
  },
  stackOffset: { marginBottom: theme.spacing(4) },
  notifications: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
  },
  notification: {
    position: "absolute",
    right: 0,
    backgroundColor: theme.palette.mono.white,
    borderRadius: theme.spacing(2),
    boxShadow: theme.elevation.standard,
    padding: theme.spacing(2),
    zIndex: 99,
  },
  firstItem: {
    zIndex: 100,
  },
  clearShadow: { boxShadow: "none" },
}));

export default useStyles;
